module.exports = __webpack_public_path__ + "img/type_draw.e7a3c93b.png";